module.exports = __webpack_public_path__ + "static/img/18.d490269.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/18.png
// module id = wf2H
// module chunks = 0